"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var css = require("./index.scss");
var omi_1 = require("omi");
var PhyScroll = require("phy-scroll");
var Scroll = /** @class */ (function (_super) {
    __extends(Scroll, _super);
    function Scroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scroll.prototype.installed = function () {
        new PhyScroll({
            touch: this.childNodes[0],
            vertical: this.props.vertical === false ? false : true,
            scroll: this.childNodes[0].firstChild,
            min: this.props.min,
            max: this.props.max,
            sensitivity: this.props.sensitivity,
            factor: this.props.factor,
            step: this.props.step,
            bindSelf: this.props.bindSelf,
            preventDefault: this.props.preventDefault === false ? false : true,
            change: this.props.onChange,
            touchStart: this.props.onTouchStart,
            touchMove: this.props.onTouchMove,
            touchEnd: this.props.onTouchEnd,
            tap: this.props.onTap,
            pressMove: this.props.onPressMove,
            animationEnd: this.props.onAnimationEnd
        });
    };
    Scroll.prototype.render = function () {
        return omi_1.h("slot", null);
    };
    Scroll.css = css;
    Scroll.propTypes = {
        vertical: Boolean
    };
    Scroll = __decorate([
        omi_1.tag('m-scroll')
    ], Scroll);
    return Scroll;
}(omi_1.WeElement));
exports.default = Scroll;
